<template>
  <div class="maintenance">
    <p class="has-info">
      De webshop is momenteel in onderhoud.<br />
      Morgen zijn we terug online.
    </p>
    <p>
      <a :href="referrer" :title="referrer" @click.prevent="retry">
        <Spinner v-show="isLoading" />
        Probeer later opnieuw
      </a>
    </p>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { getData } from "@/infrastructure/data-functions";
import { ref } from "vue";

export default {
  setup() {
    const router = useRouter();
    const referrer = router.currentRoute.value.query.u || "/";
    const store = useStore();
    // redirect to homepage when not in maintenance
    if (!store.state.data.maintenance) {
      router.replace(referrer);
      return;
    }

    const isLoading = ref(false);

    return {
      referrer,
      isLoading,
      retry: async () => {
        try {
          isLoading.value = true;
          await getData(store.state.appId);
          // no error -> maintenance is over
          store.commit("data/setMaintenance", false);
          router.replace(referrer);
        } catch (ex) {
          if (ex?.response?.data?.message === "Maintenance") {
            // state is unchanged
            return;
          }
          console.error("Loading failed", { ex, store });
        } finally {
          isLoading.value = false;
        }
      },
    };
  },
};
</script>
